export default function KenyaWorkFlow() {
  return (
    <>
      <div className="max-w-2xl mt-20 mx-auto p-6">
            <div className="h-3 w-full rounded-b rounded-full bgC bg-gradient-to-r from-pink-500 via-orange-400 to-yellow-400"></div>
            <div className="bg-white dark:bg-gray-900 shadow-lg overflow-hidden">
                <div className="   text-white text-center">
                    <div className="relative">
                    <div
                      className={`absolute -inset-4 rounded-xl  opacity-50 -z-10 transform -rotate-2`}
                    ></div>
                    <img
                      src="/img/mkspworkflow.png"
                      
                      className=" shadow-lg w-full h-80 object-cover"
                    />
                  </div>
                    <h1 className="text-2xl mt-10 font-bold dark:text-gray-300 text-gray-900">Plan de travail</h1>
                </div> 
                <div className="p-6 space-y-6">
                    <p className="text-gray-700 dark:text-gray-300 mb-10 leading-relaxed text-lg text-center">
                       MKSP vous guide pas à pas dans votre parcours étudiant au Kenya. Explorer les universités gratuitement et Créez un compte pour explorer le processus et passez en premium pour accéder aux informations exclusives.
                    </p>              
                    <div className="text-center">
                        <a
                            href="/mksp/workflow"
                            className="inline-flex items-center gap-2 bg-green-700  hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
                        >
                            Détail du Plan de travail
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div> 
    </>
  )
}
